import { Component } from 'react'
import PropTypes from 'prop-types'

class ProcessManager extends Component {
    constructor(props) {
        super(props)

        // Expose command to the dev console
        window.processstatus = this.processStatus
    }

    shouldComponentUpdate() {
        return false
    }

    // Update process status for a user
    // Example input:
    //   {
    //     "server": "tq",
    //     "username": "ccp_avalon",
    //     "isRunning": false,
    //     "crashed": true
    //   }
    processStatus = ({ crashed, username: userId, server: serverId, isRunning }) => {
        try {
            // Prioritize sending the crash notification
            if (crashed !== null && crashed === true) {
                const message = this.props.error.message.replace('{username}', userId)

                window.showError(this.props.error.title, message, 0)
            }

            // Store the change in state
            this.props.setClientProcessRunningState(serverId, userId, isRunning)
        } catch (error) {
            console.info(`Encountered error while running processStatus: ${error.message}`)
        }
    }

    render() {
        return null
    }
}

ProcessManager.propTypes = {
    error: PropTypes.shape({
        title: PropTypes.string,
        message: PropTypes.string,
    }),
    setClientProcessRunningState: PropTypes.func,
}

export default ProcessManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/ProcessManager/component.js